import React, { Component } from 'react';
import { ButtonIcon } from '@ecosystem/ui-lib/core/components/ButtonIcon';
import { withRouter} from "react-router-dom";
import {Label} from 'app/components/Basics';
import { ReactComponent as PlusIcon } from 'app/assets/icons/Plus.svg';
import { Button } from 'app/components/Basics';
import GlobalControlLine from './components/GlobalControlLine/GlobalControlLineComponent';
import GlobalFieldLine from './components/GlobalFieldLine/GlobalFieldLineComponent';
import FilterSetCard from './components/FilterSetCard/FilterSetCardComponent';
import {IndepthSetFormContext} from './InDepthContext'
import InDepthService from "../../services/indepth.service";
import  GetErrorMessage  from '../../helpers/error-message'
import {ShowError, ShowSuccess} from "../../components/toast"
import NewInDepthSet, { NewFilterSet } from './InDepthModel';
import Modal from '../../components/Modal';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import ValidateInDepthSet from './InDepthSetValidation'

class IndepthSetForm extends Component {
    constructor(props){
        super(props);
        this.state = {           
            selectedIndepthSet: NewInDepthSet(),
            errors: [],
            deleteFilterSetIndex: null,
            expandedFilterSetIndex: 0
        };
        this.filterSetRefs = {};
    }

    userCanChangeData() {
        return this.props.canChangeData;
	}

    isNetQuestSurvey() {
        return this.state.selectedIndepthSet?.isNetquest === true;
    }

    isArchived() {
        const filterSets = this.state.selectedIndepthSet?.filterSets;
        if (!filterSets || filterSets.length === 0) return false;
        return filterSets.every(fs => fs.inArchive === 1);
    }

	componentWillReceiveProps(nextProps) {
		if (nextProps.selectedIndepthSet != null) {
			const isNewSet = nextProps.selectedIndepthSet.id !== this.state.selectedIndepthSet?.id;
			const newState = { selectedIndepthSet: nextProps.selectedIndepthSet };
			if (isNewSet) {
				const filterSetCount = nextProps.selectedIndepthSet.filterSets?.length ?? 0;
				newState.expandedFilterSetIndex = filterSetCount === 1 ? 0 : null;
			}
			this.setState(newState);
		}	

        if (!isEqual(this.props.selectedIndepthSet, nextProps.selectedIndepthSet)) {
            this.setState({errors: []});            
        }
    }	

    updateselectedIndepthSet(newSelectedIndepthSet) {
		this.setState({selectedIndepthSet: newSelectedIndepthSet})
		this.props.updateselectedIndepthSet(newSelectedIndepthSet);
    }

    addErrorMessage(field, message) {
        var errors = this.state.errors;
        errors.push({ field: field, errorMessage: message});
        this.setState({errors: errors})
    }	

    SaveIndepthSet(indepthSet) {                
        this.props.toggleUiBlock(true);
        if (indepthSet.id) {
            const newFilterSets = indepthSet.filterSets.filter(fs => !fs.id);
            InDepthService.updateIndepthSet(indepthSet)
                .then(async () => {
                    // Create any new filter sets that don't have an ID yet
                    for (const filterSet of newFilterSets) {
                        await InDepthService.addFilterSet(indepthSet.id, filterSet);
                    }
                    this.props.toggleUiBlock(false);
                    this.setState({successMessage: 'The in-depth set was saved successfully' });                    
					this.props.getIndepthSetById(indepthSet.id);
                })
                .catch(error => {
					let errorMessage = GetErrorMessage(error);
					console.log("errorMessage on catch");
					console.log(errorMessage);
					this.props.toggleUiBlock(false);
					this.setState({ errorMessage: errorMessage});
                });
        }
        else {
            InDepthService.createIndepthSet(indepthSet)
                .then(async response => {					
                    const newIndepthSet = response.data;
                    // Create additional filter sets beyond the first one
                    const additionalFilterSets = indepthSet.filterSets.slice(1);
                    for (const filterSet of additionalFilterSets) {
                        await InDepthService.addFilterSet(newIndepthSet.id, filterSet);
                    }
                    this.props.toggleUiBlock(false);
                    this.setState({successMessage: 'The in-depth set was created successfully' });                                        
                    this.setState({selectedIndepthSet: newIndepthSet});					
					this.props.getIndepthSetById(newIndepthSet.id);
					
                })
                .catch(error => {
					let errorMessage = GetErrorMessage(error);
					console.log("errorMessage on catch");
					console.log(errorMessage);
					this.props.toggleUiBlock(false);
					this.setState({ errorMessage: errorMessage});
                });
        }

    }
    deleteIndepthSet = event => {
		if (this.userCanChangeData()) {    
        	this.setState({ deleteQuestionModalText: `Are you sure you want to delete the in-depth set with name '${this.state.selectedIndepthSet.name}'?`});
		}
    }

    duplicateIndepthSet = event => {        
        let clonedIndepthSet = cloneDeep(this.state.selectedIndepthSet);
        clonedIndepthSet.id = null;
        clonedIndepthSet.name = `${clonedIndepthSet.name}_copy`;
        clonedIndepthSet.filterSets = clonedIndepthSet.filterSets.map(fs => ({ ...fs, id: null }));
		this.props.updateselectedIndepthSet(clonedIndepthSet);
    }

    addFilterSet = () => {
        if (!this.userCanChangeData() || this.isNetQuestSurvey()) return;
        let selectedIndepthSet = { ...this.state.selectedIndepthSet };
        const newIndex = selectedIndepthSet.filterSets.length;
        selectedIndepthSet.filterSets = [...selectedIndepthSet.filterSets, NewFilterSet()];
        this.setState({ expandedFilterSetIndex: newIndex }, () => {
            if (this.filterSetRefs[newIndex]) {
                this.filterSetRefs[newIndex].scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        });
        this.updateselectedIndepthSet(selectedIndepthSet);
    }

    requestDeleteFilterSet = (filterSetIndex) => {
        if (!this.userCanChangeData()) return;
        const filterSets = this.state.selectedIndepthSet.filterSets;
        if (filterSets.length === 1) {
            this.setState({ deleteFilterSetModalText: `This is the last filter set. Deleting it will delete the entire in-depth set '${this.state.selectedIndepthSet.name}'. Are you sure?`, deleteFilterSetIndex: filterSetIndex });
        } else {
            const filterSetName = filterSets[filterSetIndex].name || `Filter Set ${filterSetIndex + 1}`;
            this.setState({ deleteFilterSetModalText: `Are you sure you want to delete the filter set '${filterSetName}'?`, deleteFilterSetIndex: filterSetIndex });
        }
    }

    confirmDeleteFilterSet = () => {
        const filterSetIndex = this.state.deleteFilterSetIndex;
        const filterSets = this.state.selectedIndepthSet.filterSets;
        this.hideDeleteFilterSetModal();

        if (filterSets.length === 1) {
            // Delete entire set
            this.confirmDelete();
        } else {
            let selectedIndepthSet = { ...this.state.selectedIndepthSet };
            selectedIndepthSet.filterSets = selectedIndepthSet.filterSets.filter((_, i) => i !== filterSetIndex);
            this.updateselectedIndepthSet(selectedIndepthSet);
        }
    }

    hideDeleteFilterSetModal = () => {
        this.setState({ deleteFilterSetModalText: '', deleteFilterSetIndex: null });
    }

    onFilterSetNameChange = (filterSetIndex, newName) => {
        let selectedIndepthSet = { ...this.state.selectedIndepthSet };
        selectedIndepthSet.filterSets = [...selectedIndepthSet.filterSets];
        selectedIndepthSet.filterSets[filterSetIndex] = { ...selectedIndepthSet.filterSets[filterSetIndex], name: newName };
        this.updateselectedIndepthSet(selectedIndepthSet);
    }

    confirmDelete() {        
        this.hideDeleteModal();
        this.props.toggleUiBlock(true);
        const indepthSetId = this.state.selectedIndepthSet.id;
        InDepthService.deleteIndepthSet(this.state.selectedIndepthSet)
        .then(response =>{            
            this.setState({successMessage: 'The in-depth set was deleted successfully' });            
            this.props.removeDeletedIndepthSet(indepthSetId);
			setTimeout(() => {
				this.props.toggleUiBlock(false);
				this.props.closeEditor();				
			}, 2000);

            
        })
        .catch(error => {
            let errorMessage = GetErrorMessage(error);
            console.log("errorMessage on catch");
            console.log(errorMessage);
            this.props.toggleUiBlock(false);
            this.setState({ errorMessage: errorMessage});
        });
    }

    hideDeleteModal() {
        this.setState({deleteQuestionModalText: ''})
    }    

    handleSubmitAction = event => { 
		if (this.userCanChangeData()) {
			var validationErrors = ValidateInDepthSet(this.state.selectedIndepthSet);
			this.setState({errors: validationErrors});
			if (validationErrors && validationErrors.length === 0) {                    
				this.SaveIndepthSet(this.state.selectedIndepthSet);
			}        
		}
        return;
    }

    archiveIndepthSet = event => {
        var indepthSetId = this.state.selectedIndepthSet.id;
        var newArhiveValue = this.isArchived() ? 0 : 1;        
        InDepthService.ArchiveIndepthSet(indepthSetId, newArhiveValue)
                .then(response =>{                    
                    this.props.toggleUiBlock(false);
                    var msg = newArhiveValue === 1 ? "archived" : "unarchived";
                    this.setState({successMessage: `The in-depth set was ${msg} successfully` });
					this.props.getIndepthSetById(indepthSetId);
                })
                .catch(error => {
					let errorMessage = GetErrorMessage(error);
					console.log("errorMessage on catch");
					console.log(errorMessage);
					this.props.toggleUiBlock(false);
					this.setState({ errorMessage: errorMessage});
                });
    }

    render() {

        return (        
               
            <div className="AppFormComponent InDepthForm">                 
                <IndepthSetFormContext.Provider value={{
					updateselectedIndepthSet: this.updateselectedIndepthSet.bind(this), 
					selectedIndepthSet: this.state.selectedIndepthSet,
					canChangeData: this.userCanChangeData(),
                    isNetQuestSurvey: this.isNetQuestSurvey(),
                    isArchived: this.isArchived()}}>                
                    <form ref={ form => this.formEl = form } onSubmit={ this.handleSubmitAction }>
                            <GlobalControlLine errors={this.state.errors} 
                                handleSubmitAction={this.handleSubmitAction.bind(this)} 
                                deleteIndepthSet={this.deleteIndepthSet.bind(this)}
                                duplicateIndepthSet={this.duplicateIndepthSet.bind(this)}
                                closeEditorButtonOnClick={this.props.closeEditorButtonOnClick}
                                didSelectedIndepthSetChange={this.props.didSelectedIndepthSetChange}
                                archiveIndepthSet={this.archiveIndepthSet.bind(this)}/>

                        <div className="form-head">
                            <GlobalFieldLine folders={this.props.folders} surveyTypes={this.props.metadata.surveyTypes} />

                            {this.isArchived() && (<div style={{ marginTop: '20px' }}><Label>This survey is archived!</Label></div>)}
                        </div>
                        <div className="form-sections">
                            <div className="filter-sets-header">
                                <Button 
                                    disabled={!this.userCanChangeData() || this.isNetQuestSurvey()} 
                                    secondary 
                                    icon={<PlusIcon/>} 
                                    onClick={this.addFilterSet}
                                >
                                    Filter Set
                                </Button>
                            </div>
                            <div className="filter-sets-container">
                                {this.state.selectedIndepthSet.filterSets && this.state.selectedIndepthSet.filterSets.map((filterSet, index) => (
                                    <div key={filterSet.id || `new-${index}`} ref={el => { this.filterSetRefs[index] = el; }}>
                                    <FilterSetCard
                                        filterSet={filterSet}
                                        filterSetIndex={index}
                                        expanded={this.state.expandedFilterSetIndex === index}
                                        onToggleExpand={() => this.setState({ expandedFilterSetIndex: this.state.expandedFilterSetIndex === index ? null : index })}
                                        onDeleteFilterSet={this.requestDeleteFilterSet}
                                        onFilterSetNameChange={this.onFilterSetNameChange}
                                        metadata={this.props.metadata}
                                        errors={this.state.errors}
                                        isAskAlwaysEnabled={this.props.isAskAlwaysEnabled}
                                    />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </form>                    
                </IndepthSetFormContext.Provider>

                {this.state.errorMessage && ( <ShowError clearErrorMessage={() => this.setState({errorMessage: ''})} errorMessage={this.state.errorMessage} /> )}
                {this.state.successMessage && ( <ShowSuccess clearMessage={() => this.setState({successMessage: ''})} message={this.state.successMessage} /> )}
                {this.state.deleteQuestionModalText && ( <Modal content={this.state.deleteQuestionModalText} size="small" confirmModalHandler={this.confirmDelete.bind(this)} cancelModalHandler={this.hideDeleteModal.bind(this)} />)}
                {this.state.deleteFilterSetModalText && ( <Modal content={this.state.deleteFilterSetModalText} size="small" confirmModalHandler={this.confirmDeleteFilterSet} cancelModalHandler={this.hideDeleteFilterSetModal} />)}
            </div>            
        );
    }
}
export default withRouter(IndepthSetForm); 